import {
  FETCH_POIS,
  FETCH_POIS_ERROR,
  SET_POIS,
  LOG_OUT,
} from '../constants';

import { GroupTheBoundaries } from '../../utilities/report-helpers';

const initialState = {
  poisDataLoaded: false,
  poisData: [],
};



const pois = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case FETCH_POIS:
      return {
        ...state,
        poisDataLoaded: false,
      };
    case FETCH_POIS_ERROR:
      return {
        ...state,
        poisDataLoaded: false,
      };
    case SET_POIS:
      return {
        ...state,
        poisDataLoaded: true,
        poisData : GroupTheBoundaries(action.data,'pois')
      };
    default:
      return state;
  }
};

export default pois;
